import { FINANCIAL_STATUS, FINANCIAL_TYPES } from "../../../../constants/financial";

const todayStr = () => new Date().toISOString().split("T")[0];

/**
 * processCashflowTimeline
 * Função Pura: Recebe os registros brutos do Cashflow, faz engine matemática, agrupa dias e gera o timeline.
 */
export const processCashflowTimeline = (records, currentTotalBalance, startDate) => {
    if (!records || !records.length) return [];

    const today = todayStr();
    const grouped = {};
    const overdueKey = 'OVERDUE_OR_TODAY';

    records.forEach(r => {
        // Data efetiva: paymentDate para PAID, dueDate para PENDING/OVERDUE
        const effectiveDate = r.status === FINANCIAL_STATUS.PAID
            ? (r.paymentDate || r.dueDate || today)
            : (r.dueDate || today);

        // Atrasados ou vence hoje → agrupa no bloco especial
        const isRetroactive = effectiveDate < startDate;
        const dateKey = isRetroactive ? overdueKey : effectiveDate;

        if (!grouped[dateKey]) {
            grouped[dateKey] = {
                date: dateKey,
                displayDate: dateKey === overdueKey
                    ? 'Atrasados / Anteriores'
                    : dateKey.split('-').reverse().join('/'),
                income: 0,
                expense: 0,
                paidIncome: 0,
                paidExpense: 0,
                records: [],
                isOverdue: dateKey === overdueKey
            };
        }

        grouped[dateKey].records.push(r);

        const amount = r.netAmount || 0;
        if (r.type === FINANCIAL_TYPES.ASSET) { 
            grouped[dateKey].income += amount;
            if (r.status === FINANCIAL_STATUS.PAID) grouped[dateKey].paidIncome += amount;
        }
        if (r.type === FINANCIAL_TYPES.LIABILITY) {
            grouped[dateKey].expense += amount;
            if (r.status === FINANCIAL_STATUS.PAID) grouped[dateKey].paidExpense += amount;
        }
    });

    // Remove grupo especial se vazio
    if (grouped[overdueKey] && grouped[overdueKey].records.length === 0) {
        delete grouped[overdueKey];
    }

    // Ordenar chaves
    const sortedKeys = Object.keys(grouped).sort((a, b) => {
        if (a === overdueKey) return -1;
        if (b === overdueKey) return 1;
        return a.localeCompare(b);
    });

    // ── Calcular saldo base (antes do período) ──
    // O saldo bancário atual INCLUI todos os registros PAID.
    // Para reconstruir a timeline dia a dia, precisamos "voltar" o saldo
    // ao estado antes do período, subtraindo todos os PAID do período,
    // e depois re-acumular dia a dia (PAID + PENDING).
    let totalPaidNet = 0;
    sortedKeys.forEach(key => {
        const dayData = grouped[key];
        totalPaidNet += (dayData.paidIncome - dayData.paidExpense);
    });

    // Saldo base = saldo atual do banco - tudo que foi PAID neste período
    const baseBalance = currentTotalBalance - totalPaidNet;

    const timeline = [];
    let runningBalance = baseBalance;

    sortedKeys.forEach(key => {
        const dayData = grouped[key];
        // Acumula entradas e saídas totais (PAID + PENDING) para reconstituir a projeção
        const dayNet = dayData.income - dayData.expense;
        runningBalance += dayNet;

        timeline.push({
            ...dayData,
            netDay: dayNet,
            projectedBalance: runningBalance
        });
    });

    return timeline;
};
